import { render, staticRenderFns } from "./MaterialTemplateList.vue?vue&type=template&id=73b6ce00&scoped=true&"
import script from "./MaterialTemplateList.vue?vue&type=script&lang=js&"
export * from "./MaterialTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b6ce00",
  null
  
)

export default component.exports